import { isPublicApiEnabledFor } from "@/utils/apiKeys";

export const PUBLIC_API_DOCS_URL = "https://openapi.dentcloud.app/docs";
export const PUBLIC_API_ENABLED = isPublicApiEnabledFor(process.env.VUE_APP_TENANT);
